import React, {useState} from 'react'
import {IconButton, Tooltip} from '@material-ui/core';
import HelpDialog from './HelpDialog';
import HelpIcon from '@material-ui/icons/Help'
import Tr from 'translations/Translations';

function Help() {
	const [open, setOpen] = useState(false)
	return (<>
		<Tooltip title={Tr('help')}>
			<IconButton onClick={() => setOpen(true)}>
				<HelpIcon/>
			</IconButton>
		</Tooltip>
		<HelpDialog open={open} onClose={() => setOpen(false)} />
		</>
	)
}

Help.propTypes = {
}

Help.defaultProps = {
}

export default Help;
